export default __webpack_public_path__ + "images/0xd31fcd1f7ba190dbc75354046f6024a9b86014d7.png";